import styled from 'styled-components';

export const Image = styled.img<{ aspect?: number; fit?: string }>`
  ${({ aspect }) => aspect && `aspect-ratio: ${aspect};`}
  ${({ fit }) => fit && `object-fit: ${fit};`}
  max-height: inherit;
`;
Image.defaultProps = {
  loading: 'lazy',
  decoding: 'async',
};
